import React, {useCallback} from 'react';
import { IconButton } from "@material-ui/core";

import { ChevronLeftIcon } from '../../icon/solid';

type Props = {
  changePage: (page: number) => void;
  page: number;
}

const PreviousPageAction = ({ changePage, page }: Props) => {

  const onChange = useCallback(() => {
    changePage(page - 1);
  },[changePage, page]);

  return (
    <IconButton onClick={onChange} disabled={page === 0}>
      <ChevronLeftIcon/>
    </IconButton>
  );
};

export default PreviousPageAction;
